import moment from "moment";
import { ResidentLogs } from "@/enums/ResidentLogs";
import { mapState } from "vuex";
import * as firebase from "firebase";
import { countByKeys } from "@/utils/countByKeys";
import { reportPeriods } from "@/consts/reportPeriods";

export default {
  name: "Report360ViewServices",
  props: {
    residentId: {
      type: String,
      default: null
    },
    period: {
      type: Number,
      default: 7
    },
    isPrintableMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    async period(value) {
      this.period = value

      await this.loadReportData(value)
    }
  },
  data() {
    return {
      selectedResidentId: null,
      periods: reportPeriods,
      ResidentLogs: ResidentLogs,
      Logs: {
        [ResidentLogs.OpennedService]: {
          items: []
        },
        [ResidentLogs.ViewService]: {
          items: [],
          percent: 0
        }
      },
      Services: {
        Categories: {
          items: []
        },
        Provider: {
          items: []
        }
      },
      headers: [
        {
          text: this.$t('GeneralTranslations.Service'),
          value: "extraData.serviceName"
        },
        {
          text: this.$t('GeneralTranslations.Provider'),
          value: "extraData.providerName"
        },
        {
          text: this.$t('Report360View.EventsReport.Clicks'),
          value: "click"
        }
      ]
    }
  },
  computed: {
    ...mapState({
      facility() {
        return this.$store.state.authModule.currentFacility;
      },
      resident() {
        return this.$store.state.residentModule.currentResident;
      },
      residentLogs() {
        return this.$store.state.residentModule.residentLogs;
      },
    }),
    ServiceOpenLogs() {
      const arr = this.Logs[ResidentLogs.OpennedService].items;
      if (arr.length) {
        let result = arr.reduce((total, current) => {
          const key = current.extraData.providerName; //appName
          if (key) {
            if (total[key]) {
              total[key].click++
            } else {
              total[key] = {
                click: 1,
                ...current
              }
            }
          }

          return total;
        }, {});
        result = Object.values(result);
        return result;
      }
    },
    ServiceViewLogs() {
      return this.Logs[ResidentLogs.ViewService].items;
    },
    ServiceProvider() {
      const arr = this.$store.state.additionalServicesModule.residentServicesMonth;
      return countByKeys(arr, "providerName");
    },
    ServiceCategory() {
      const arr = this.$store.state.additionalServicesModule.residentServicesMonth;
      return countByKeys(arr, "category");
    }
  },
  methods: {
    async loadReportData(period) {
      this.period = period

      await this.getResidentLogs(this.period, [
        ResidentLogs.OpennedService,
        ResidentLogs.ViewService
      ]);

      await this.getResidentServices(this.period);
    },
    async getResidentLogs(period, eventTypes) {
      const fromDate = moment()
        .subtract(period, "days")
        .toDate();

      await firebase
        .firestore()
        .collection("residents")
        .doc(this.selectedResidentId)
        .collection("events")
        .where("facilityId", "==", this.facility)
        .where("eventDateTime", ">=", fromDate)
        .where("eventType", "in", eventTypes)
        .get()
        .then(querySnapshot => {
          const logs = querySnapshot.docs.map(log => {
            const data = log.data();
            const start = moment(data.eventDateTime.seconds * 1000).toDate();
            const extraData = JSON.parse(data.extraData.replace(/'/g, '"'));
            data.start = start;
            data.extraData = extraData;
            return {
              ...data
            };
          });

          const logsResult = logs.reduce((total, current) => {
            const key = current.eventType;
            if (total[key]) {
              total[key].push(current);
            } else {
              total[key] = [current];
            }
            return total;
          }, {});

          Object.keys(logsResult).forEach(key => {
            this.Logs[key].items = logsResult[key];
            const arr: any = Object.values(this.getDailyCount(this.Logs[key].items)).splice(-2);
            if (arr.length === 2) {
              const num1 = arr[0];
              const num2 = arr[1];
              const result = (num2 - num1) / num1 * 100;
              this.Logs[key].percent = result.toFixed(0);
            }
          });

          eventTypes.forEach(type => {
            if (!Object.keys(logsResult).includes(type)) {
              this.Logs[type].items = [];
              this.Logs[type].percent = 0;
            }
          });
        });
    },
    async getResidentServices(period) {
      this.Services.Categories.items = [];
      this.Services.Provider.items = [];

      this.Logs[ResidentLogs.ViewService].items = [];
      await this.$store.dispatch("getResidentServices", {
        residentId: this.selectedResidentId,
        duration: period
      });
    },
    getDailyCount(events) {
      const types = events.reduce(function (totals, event) {
        const date = moment(event.start)
          .startOf("day")
          .format("D/MM");
        !totals[date] ? (totals[date] = 1) : (totals[date] = totals[date] + 1);
        return totals;
      }, {});
      return types;
    },
    backToReport360() {
      this.$router.push(`/reports/reports360/${this.selectedResidentId}`);
    }
  },
  async created() {
    this.selectedResidentId = this.residentId || this.$route.params.id

    this.$store.dispatch("getFacility");

    this.$store.dispatch("getResident", this.selectedResidentId);

    await this.loadReportData(this.period)

    this.$emit('report360ViewServicesDataLoaded')
  }
};
